<template>
  <v-container class="pa-3" fluid v-if="myRun">
    <v-layout wrap>
      <v-flex class="px-2" md3 xs12>
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.heliospheric_model.cluster.walltime)"
          @blur="$v.myRun.config.heliospheric_model.cluster.walltime.$touch()"
          @input="$v.myRun.config.heliospheric_model.cluster.walltime.$touch()"
          hint="Walltime specified in hh:mm format"
          label="Walltime"
          mask="time"
          v-model="myRun.config.heliospheric_model.cluster.walltime"
        ></v-text-field>
      </v-flex>
      <v-flex class="px-2" md3 xs12>
        <v-select :items="ppn" label="Processes per node" v-model="myRun.config.heliospheric_model.cluster.ppn"></v-select>
      </v-flex>
      <v-flex class="px-2" md3 xs12>
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.heliospheric_model.cluster.nodes)"
          @blur="$v.myRun.config.heliospheric_model.cluster.nodes.$touch()"
          @input="$v.myRun.config.heliospheric_model.cluster.nodes.$touch()"
          label="Number of nodes"
          type="number"
          v-model="myRun.config.heliospheric_model.cluster.nodes"
        ></v-text-field>
      </v-flex>
      <v-flex class="px-2" md3 xs12>
        <v-select :items="vscAccounts" label="Account" v-model="myRun.config.heliospheric_model.cluster.account"></v-select>
      </v-flex>
      <v-flex class="px-2" xs12>
        <span class="caption">Estimated price: {{ price }} credits</span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import runMixin from '@/mixins/run';
import meMixin from '@/mixins/me';

export default {
  mixins: [runMixin, meMixin],
  data() {
    return {
      ppn: [
        // { text: '20 (Ivy Bridge) ', value: 20, price: 4.76 },
        { text: '24 (ThinKing - Haswell)', value: 24, price: 6.68 },
        { text: '36 (Genius - Skylake)', value: 36, price: 10 },
      ],
    };
  },
  created() {
    if (this.myRun.config.heliospheric_model.cluster.ppn === 20) {
      this.myRun.config.heliospheric_model.cluster.ppn = 24;
    }
  },
  computed: {
    price() {
      try {
        const hours = parseInt(this.myRun.config.heliospheric_model.cluster.walltime.substr(0, 2));
        const minutes = parseInt(this.myRun.config.heliospheric_model.cluster.walltime.substr(2, 2));
        const price = this.ppn.find((obj) => obj.value === this.myRun.config.heliospheric_model.cluster.ppn).price;
        return Math.round(
          0.000278 * this.myRun.config.heliospheric_model.cluster.nodes * (hours * 3600 + minutes * 60) * price
        );
      } catch (error) {
        return 0;
      }
    },
  },
};
</script>
